import React, { ReactElement } from 'react';

interface IProps {}

function Authenticate(props: IProps): ReactElement {
  return <h1>Authenticating...</h1>;
}

export default Authenticate;
